import { Mail, MessageCircle } from "lucide-react";
import type { AccountProvider, MessageDirection, StepChannel } from "../types";
import {
  resolveInboxIconKind,
  resolveInboxMessageIconKind,
  type InboxIconKind,
} from "../inbox-provider-icon";
import { GmailBrand, LinkedinBrand, OutlookBrand } from "./BrandIcons";

const INBOX_ICON: Record<InboxIconKind, typeof Mail> = {
  mail: Mail,
  gmail: GmailBrand,
  outlook: OutlookBrand,
  linkedin: LinkedinBrand,
  whatsapp: MessageCircle,
};

export function getInboxIcon(
  channel: StepChannel | null | undefined,
  provider?: AccountProvider | null,
): typeof Mail {
  return INBOX_ICON[resolveInboxIconKind(channel, provider)];
}

export function getInboxMessageIcon(
  channel: StepChannel | null | undefined,
  direction: MessageDirection | null | undefined,
  provider?: AccountProvider | null,
): typeof Mail {
  return INBOX_ICON[resolveInboxMessageIconKind(channel, direction, provider)];
}
